import { Images } from "../../../Images";
import BigNum from "../../math/BigNum";
import Values from "../../value/Values";
import UpgradeAutomationSkillNode from "./UpgradeAutomationSkillNode";
import { SkillIds } from "../SkillIds";
import SkillType from "../SkillType";
import AutomationUnlockSkillNode from "./AutomationUnlockSkillNode";

export default class PickUpgradeAutomationSkill extends SkillType {
    /**
     * @param {Totals} totals
     * @param {Values} values
     */
    constructor(totals, values) {
        super(SkillIds.PICK_AUTOMATION);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;

        const inc = 5;
        let cost = 5;

        const pickAutomationUnlock = this.addNode(new AutomationUnlockSkillNode('pickAutomationUnlock', 'Auto Purchase', 'Ore Upgrades', 
            totals, Images.pick, new BigNum(cost), this, this.values.pickAutomationUnlocked));

        cost += inc;

        const pickAutomationBonus1 = this.addNode(new UpgradeAutomationSkillNode('pickAutomationBonus1', 
            totals, Images.pick, new BigNum(cost), this, this.values.pickAutomationRateUpgrades
        ));

        cost += inc;

        const pickAutomationBonus2 = this.addNode(new UpgradeAutomationSkillNode('pickAutomationBonus2', 
            totals, Images.pick, new BigNum(cost), this, this.values.pickAutomationRateUpgrades
        ));

        cost += inc;

        const pickAutomationBonus3 = this.addNode(new UpgradeAutomationSkillNode('pickAutomationBonus3', 
            totals, Images.pick, new BigNum(cost), this, this.values.pickAutomationRateUpgrades
        ));

        cost += inc;

        const pickAutomationBonus4 = this.addNode(new UpgradeAutomationSkillNode('pickAutomationBonus4', 
            totals, Images.pick, new BigNum(cost), this, this.values.pickAutomationRateUpgrades
        ));

        cost += inc;

        const pickAutomationBonus5 = this.addNode(new UpgradeAutomationSkillNode('pickAutomationBonus5', 
            totals, Images.pick, new BigNum(cost), this, this.values.pickAutomationRateUpgrades
        ));

        cost += inc;

        const pickAutomationBonus6 = this.addNode(new UpgradeAutomationSkillNode('pickAutomationBonus6', 
            totals, Images.pick, new BigNum(cost), this, this.values.pickAutomationRateUpgrades
        ));

        cost += inc;

        const pickAutomationBonus7 = this.addNode(new UpgradeAutomationSkillNode('pickAutomationBonus7', 
            totals, Images.pick, new BigNum(cost), this, this.values.pickAutomationRateUpgrades
        ));

        cost += inc;

        const pickAutomationBonus8 = this.addNode(new UpgradeAutomationSkillNode('pickAutomationBonus8', 
            totals, Images.pick, new BigNum(cost), this, this.values.pickAutomationRateUpgrades
        ));

        cost += inc;

        const pickAutomationBonus9 = this.addNode(new UpgradeAutomationSkillNode('pickAutomationBonus9', 
            totals, Images.pick, new BigNum(cost), this, this.values.pickAutomationRateUpgrades
        ));

        cost += inc;

        const pickAutomationBonus10 = this.addNode(new UpgradeAutomationSkillNode('pickAutomationBonus10', 
            totals, Images.pick, new BigNum(cost), this, this.values.pickAutomationRateUpgrades
        ));

        cost += inc;

        const pickAutomationBonus11 = this.addNode(new UpgradeAutomationSkillNode('pickAutomationBonus11', 
            totals, Images.pick, new BigNum(cost), this, this.values.pickAutomationRateUpgrades
        ));

        cost += inc;

        const pickAutomationBonus12 = this.addNode(new UpgradeAutomationSkillNode('pickAutomationBonus12', 
            totals, Images.pick, new BigNum(cost), this, this.values.pickAutomationRateUpgrades
        ));


        pickAutomationUnlock.addChildNode(pickAutomationBonus1);

        pickAutomationBonus1.addChildNode(pickAutomationBonus2);
        pickAutomationBonus2.addChildNode(pickAutomationBonus3);
        pickAutomationBonus3.addChildNode(pickAutomationBonus4);
        pickAutomationBonus4.addChildNode(pickAutomationBonus5);
        pickAutomationBonus5.addChildNode(pickAutomationBonus6);
        pickAutomationBonus6.addChildNode(pickAutomationBonus7);
        pickAutomationBonus7.addChildNode(pickAutomationBonus8);
        pickAutomationBonus8.addChildNode(pickAutomationBonus9);
        pickAutomationBonus9.addChildNode(pickAutomationBonus10);
        pickAutomationBonus10.addChildNode(pickAutomationBonus11);
        pickAutomationBonus11.addChildNode(pickAutomationBonus12);

        ///////////////////////////////////
        // Position the nodes in the graph
        ///////////////////////////////////

        // Starting coordinate of the skill
        const startX = -1;
        const startY = 8;

        pickAutomationUnlock.setPosition(startX, startY);

        pickAutomationBonus1.setPosition(startX - 1, startY);
        pickAutomationBonus2.setPosition(startX - 2, startY);
        pickAutomationBonus3.setPosition(startX - 3, startY);
        pickAutomationBonus4.setPosition(startX - 4, startY);
        pickAutomationBonus5.setPosition(startX - 5, startY);
        pickAutomationBonus6.setPosition(startX - 6, startY);
        pickAutomationBonus7.setPosition(startX - 6, startY - 1);
        pickAutomationBonus8.setPosition(startX - 5, startY - 1);
        pickAutomationBonus9.setPosition(startX - 4, startY - 1);
        pickAutomationBonus10.setPosition(startX - 3, startY - 1);
        pickAutomationBonus11.setPosition(startX - 2, startY - 1);
        pickAutomationBonus12.setPosition(startX - 1, startY - 1);

    }
    
}